// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 5: الكنيسة الأولى
// ============================================================================
// المستويات 53-65 (13 مستوى، 39 سؤال)

export const chapter5Translations = {
  name: "الكنيسة الأولى",
  description: "وستنالون قوة...",
  
  spiritualWisdom: {
    principle: "الروح القدس يمنح القوة والشجاعة للشهادة",
    scripture: "لكِنَّكُمْ سَتَنَالُونَ قُوَّةً مَتَى حَلَّ الرُّوحُ الْقُدُسُ عَلَيْكُمْ، وَتَكُونُونَ لِي شُهُودًا (أعمال 1: 8)",
    application: "تولد الكنيسة في نار الروح وتنمو بالشهادة الشجاعة"
  },
  
  levels: {
    53: {
      name: "الصعود",
      challenge: "ستكونون لي شهوداً... إلى أقصى الأرض...",
      easy: {
        question: "بعد كم يوماً من قيامته صعد يسوع إلى السماء؟",
        options: ["30 يوماً", "40 يوماً", "50 يوماً", "60 يوماً"],
        hint: "العدد الكتابي للإعداد",
        funFact: "☁️ 40 يوماً من التعليم المكثف قبل المهمة العالمية!"
      },
      medium: {
        question: "ما الوعد الذي قطعه يسوع قبل صعوده إلى السماء؟",
        options: [
          "سيعود قريباً",
          "سيرسل الروح القدس بقوة",
          "سيبني كنيسة",
          "سيعاقب الأشرار"
        ],
        hint: "قوة من العلاء",
        funFact: "⚡ وعد الروح القدس - تحويل التلاميذ الخائفين!"
      },
      hard: {
        question: "ماذا يرمز الصعود في حياتنا الروحية؟",
        options: [
          "نهاية حضور يسوع",
          "يسوع يملك ويشفع لنا في السماء",
          "انفصال نهائي",
          "أسطورة رمزية"
        ],
        hint: "يتعلق الأمر بحضوره الممجد والنشط",
        funFact: "👑 يسوع يملك عن يمين الله ويشفع لنا!"
      }
    },
    
    54: {
      name: "العنصرة",
      challenge: "امتلأوا جميعاً من الروح القدس وابتدأوا يتكلمون...",
      easy: {
        question: "بعد كم يوماً من الصعود حدثت العنصرة؟",
        options: ["7 أيام", "10 أيام", "14 يوماً", "20 يوماً"],
        hint: "عشرة أيام",
        funFact: "🔟 10 أيام من الصلاة المكثفة تُعد لانسكاب الروح!"
      },
      medium: {
        question: "بأي شكل ظهر الروح القدس؟",
        options: [
          "كريح عاصفة",
          "كألسنة نار",
          "كحمامة",
          "كنور"
        ],
        hint: "ألسنة تستقر على كل تلميذ",
        funFact: "🔥 ألسنة النار: الروح يمنح الشجاعة وموهبة الألسنة!"
      },
      hard: {
        question: "ماذا تمثل العنصرة للكنيسة الجامعة؟",
        options: [
          "حدث تاريخي منعزل",
          "الميلاد الرسمي للكنيسة الإرسالية",
          "معجزة فضول",
          "بداية الاحتفالات"
        ],
        hint: "يتعلق الأمر بشهادة ميلاد الكنيسة",
        funFact: "🎂 العنصرة = عيد ميلاد الكنيسة، بداية المهمة العالمية!"
      }
    },

    55: {
      name: "عظة بطرس الأولى",
      challenge: "ماذا نفعل أيها الرجال الإخوة؟ توبوا...",
      easy: {
        question: "كم شخصاً تعمدوا بعد عظة بطرس؟",
        options: ["1000", "2000", "3000", "5000"],
        hint: "ثلاثة آلاف نفس",
        funFact: "🌊 3000 معمودية في يوم واحد - صحوة روحية استثنائية!"
      },
      medium: {
        question: "بماذا اتهم بطرس الجمع؟",
        options: [
          "بالجهل",
          "بصلب يسوع المسيح",
          "بنقص الإيمان",
          "بالنفاق"
        ],
        hint: "الجريمة العظمى ضد ابن الله",
        funFact: "⚔️ بطرس، الذي أنكر يسوع، يعلن الآن ألوهيته!"
      },
      hard: {
        question: "كيف يوضح تحول بطرس عمل الروح القدس؟",
        options: [
          "يصبح أكثر تعلماً",
          "من جبان وغير مستقر، يصبح شجاعاً وثابتاً في الإيمان",
          "يكتسب قوى",
          "يتغير شخصيته"
        ],
        hint: "يتعلق الأمر بالتقديس بالروح",
        funFact: "🗿 'القصبة المهتزة' تصبح 'صخرة ثابتة' - قوة تحويلية!"
      }
    },

    56: {
      name: "الجماعة الأولى",
      challenge: "كانوا يواظبون على تعليم الرسل والشركة...",
      easy: {
        question: "كيف كان المسيحيون الأوائل يتقاسمون ممتلكاتهم؟",
        options: [
          "كل واحد يحتفظ بما له",
          "كان لهم كل شيء مشتركاً",
          "الأغنياء فقط يعطون",
          "بواجب قانوني"
        ],
        hint: "جماعة أموال طوعية",
        funFact: "🤝 محبة أخوية شديدة حتى أنهم يتقاسمون كل شيء تلقائياً!"
      },
      medium: {
        question: "على ماذا كان المسيحيون الأوائل يواظبون؟",
        options: [
          "على الأعمال فقط",
          "التعليم، الشركة، كسر الخبز، الصلوات",
          "على العمل فقط",
          "على الترفيه"
        ],
        hint: "أربع ركائز للحياة الجماعية",
        funFact: "⛪ التعليم، الشركة، الإفخارستيا، الصلاة - أسس الكنيسة!"
      },
      hard: {
        question: "لماذا كانت هذه الجماعة الأولى جذابة جداً؟",
        options: [
          "كانت غنية",
          "المحبة الحقيقية والفرح يشعان من وحدتهم",
          "وعدت بالمعجزات",
          "انتقدت الآخرين"
        ],
        hint: "يتعلق الأمر بشهادة المحبة المعاشة",
        funFact: "✨ 'انظروا كيف يحبون بعضهم!' - شهادة تقنع أكثر من الكلمات!"
      }
    },

    57: {
      name: "شفاء الأعرج",
      challenge: "ليس لي فضة ولا ذهب، ولكن الذي لي فإياه أعطيك...",
      easy: {
        question: "منذ متى كان الرجل أعرج؟",
        options: [
          "منذ 20 سنة",
          "منذ 30 سنة", 
          "منذ ولادته",
          "منذ 10 سنوات"
        ],
        hint: "عاهة منذ الأبد",
        funFact: "🚶 40 سنة من العاهة شُفيت فوراً باسم يسوع!"
      },
      medium: {
        question: "باسم من شفى بطرس الأعرج؟",
        options: [
          "باسم الله",
          "باسم يسوع المسيح الناصري",
          "باسمه الخاص",
          "باسم إبراهيم"
        ],
        hint: "الاسم الذي فوق كل اسم",
        funFact: "✊ اسم يسوع يستمر في صنع المعجزات عبر الرسل!"
      },
      hard: {
        question: "ماذا ترمز هذه المعجزة للإنجيل؟",
        options: [
          "معجزة طبية بسيطة",
          "الخلاص الكامل الذي يجلبه يسوع: روحي وجسدي",
          "قوة الرسل",
          "الإحسان للفقراء"
        ],
        hint: "يتعلق الأمر بالخلاص الكامل للإنسان",
        funFact: "🩺 يسوع يشفي الروح والجسد - خلاص كامل للشخص!"
      }
    },

    58: {
      name: "الاضطهاد يبدأ",
      challenge: "ينبغي أن يُطاع الله أكثر من الناس...",
      easy: {
        question: "من اعتقل بطرس ويوحنا بعد شفاء الأعرج؟",
        options: [
          "الرومان",
          "الصدوقيون والكهنة",
          "الشعب",
          "بيلاطس"
        ],
        hint: "السلطات الدينية اليهودية",
        funFact: "⛓️ أول اضطهاد ديني - الإنجيل يزعج المؤسسة!"
      },
      medium: {
        question: "ما المنع الذي أصدرته السلطات للرسل؟",
        options: [
          "مغادرة أورشليم",
          "عدم التعليم باسم يسوع",
          "عدم صنع المعجزات",
          "عدم الصلاة"
        ],
        hint: "منع الوعظ",
        funFact: "🚫 محاولة إسكات الحق - من المستحيل إيقاف الإنجيل!"
      },
      hard: {
        question: "كيف تفاعل الرسل مع المنع؟",
        options: [
          "أطاعوا خوفاً",
          "أكدوا وجوب طاعة الله أكثر من الناس",
          "تفاوضوا",
          "هربوا"
        ],
        hint: "يتعلق الأمر بولاء أعلى من القوانين البشرية",
        funFact: "⚖️ عصيان مدني لطاعة الله - شجاعة القناعة!"
      }
    },

    59: {
      name: "حنانيا وسفيرة",
      challenge: "أنت لم تكذب على الناس بل على الله...",
      easy: {
        question: "ما الكذبة التي قالها حنانيا وسفيرة؟",
        options: [
          "لم يبيعا شيئاً",
          "أعطيا كل ثمن بيعهما بينما احتفظا بجزء منه",
          "كانا فقيرين",
          "لم يكونا متزوجين"
        ],
        hint: "كذب حول المبلغ المعطى",
        funFact: "💰 الاحتفاظ بجزء كان مسموحاً، الكذب حول العطية لم يكن!"
      },
      medium: {
        question: "ماذا حدث لهما بعد كذبهما؟",
        options: [
          "غُفر لهما",
          "ماتا فجأة",
          "طُردا",
          "تابا"
        ],
        hint: "عقاب فوري وصارم",
        funFact: "⚱️ حكم صارم للحفاظ على نقاء الكنيسة الناشئة!"
      },
      hard: {
        question: "لماذا هذا العقاب الصارم في بداية الكنيسة؟",
        options: [
          "كان الله قاسياً",
          "لتأسيس القداسة المطلوبة في الجماعة",
          "لإخافة الناس",
          "بالصدفة"
        ],
        hint: "يتعلق الأمر بالحفاظ على النزاهة الروحية",
        funFact: "🔥 معايير عالية في البداية لتأسيس ثقافة القداسة!"
      }
    },

    60: {
      name: "الشمامسة السبعة",
      challenge: "اختاروا منكم سبعة رجال مشهوداً لهم...",
      easy: {
        question: "كم شماساً تم اختيارهم؟",
        options: ["5", "6", "7", "12"],
        hint: "عدد الكمال",
        funFact: "7️⃣ سبعة شمامسة للخدمة - تنظيم إلهي للكنيسة!"
      },
      medium: {
        question: "ما كان دورهم الرئيسي؟",
        options: [
          "الوعظ بالإنجيل",
          "الخدمة على الموائد ومساعدة الأرامل",
          "تعميد المتحولين الجدد",
          "إدارة المالية"
        ],
        hint: "خدمة اجتماعية ومادية",
        funFact: "🍽️ خدمة الموائد = أول منظمة خيرية مسيحية!"
      },
      hard: {
        question: "ماذا يكشف هذا التنظيم عن الرؤية المسيحية للخدمة؟",
        options: [
          "المهام المادية أدنى",
          "الخدمة الروحية والمادية كلاهما مقدستان",
          "يجب فصل المقدس عن الدنيوي",
          "الكهنة فقط يخدمون حقاً"
        ],
        hint: "يتعلق الأمر بقدسية كل خدمة محبة",
        funFact: "✨ الخدمة على الموائد بنفس كرامة الوعظ - كل خدمة مقدسة!"
      }
    },

    61: {
      name: "استفانوس، أول شهيد",
      challenge: "يا رب لا تقم لهم هذه الخطية! وإذ قال هذا رقد...",
      easy: {
        question: "ما كانت وظيفة استفانوس في الكنيسة؟",
        options: ["رسول", "شماس", "كاهن", "نبي"],
        hint: "واحد من السبعة المختارين للخدمة",
        funFact: "✨ استفانوس: شماس أصبح مبشراً قوياً وأول شهيد!"
      },
      medium: {
        question: "بماذا اتهم استفانوس القادة اليهود؟",
        options: [
          "بالفساد",
          "بمقاومة الروح القدس دائماً",
          "بالنفاق",
          "بالطمع"
        ],
        hint: "مقاومة تاريخية لله",
        funFact: "📜 استفانوس يلخص التاريخ: تمرد مستمر ضد الله!"
      },
      hard: {
        question: "كيف مات استفانوس وماذا تكشف موقفه؟",
        options: [
          "في الغضب ضد جلاديه",
          "في المغفرة مثل يسوع على الصليب",
          "في اليأس",
          "في لعن أعدائه"
        ],
        hint: "يتعلق الأمر بالتقليد الكامل للمسيح",
        funFact: "💝 مغفرة الجلادين: استفانوس يعيد إنتاج موقف يسوع تماماً!"
      }
    },

    62: {
      name: "فيلبس والخصي الإثيوبي",
      challenge: "كيف يمكنني أن أفهم إن لم يرشدني أحد؟",
      easy: {
        question: "ماذا كان يقرأ الخصي في مركبته؟",
        options: [
          "المزامير",
          "إشعياء النبي",
          "التكوين",
          "الأمثال"
        ],
        hint: "نبي آلام المسيح",
        funFact: "📖 إشعياء 53 - نبوءة كاملة عن يسوع يقرأها باحث صادق!"
      },
      medium: {
        question: "كيف شرح فيلبس مقطع إشعياء؟",
        options: [
          "تحدث عن تاريخ قديم",
          "بشَّر بيسوع انطلاقاً من هذا النص",
          "أعطى درساً في اللاهوت",
          "انتقد التفسيرات"
        ],
        hint: "الكتاب المقدس يقود بشكل طبيعي إلى المسيح",
        funFact: "✝️ كل الكتاب المقدس يتقارب نحو يسوع - مفتاح الفهم!"
      },
      hard: {
        question: "ماذا يرمز تحول الخصي الإثيوبي؟",
        options: [
          "تحول منعزل",
          "عالمية الإنجيل لجميع الأجناس والأحوال",
          "تفوق شعوب معينة",
          "حالة خاصة"
        ],
        hint: "يتعلق الأمر بالانفتاح على الأمم",
        funFact: "🌍 إثيوبي، خصي، وزير: الإنجيل يكسر كل الحواجز!"
      }
    },

    63: {
      name: "تحول شاول الطرسوسي",
      challenge: "شاول، شاول، لماذا تضطهدني؟",
      easy: {
        question: "ماذا كان يفعل شاول قبل تحوله؟",
        options: [
          "كان يعظ بالإنجيل",
          "كان يضطهد المسيحيين",
          "كان محايداً",
          "كان يدرس فقط"
        ],
        hint: "عدو متعصب للتلاميذ",
        funFact: "⚔️ كان شاول ينفث تهديداً وقتلاً ضد تلاميذ يسوع!"
      },
      medium: {
        question: "على أي طريق ظهر يسوع لشاول؟",
        options: [
          "طريق أورشليم",
          "طريق دمشق",
          "طريق غزة",
          "طريق أنطاكية"
        ],
        hint: "مدينة في سوريا",
        funFact: "🛤️ طريق دمشق = مكان التحول الأشهر في التاريخ!"
      },
      hard: {
        question: "كيف يوضح هذا التحول النعمة الإلهية؟",
        options: [
          "الله يحول الأخيار فقط",
          "النعمة يمكنها تحويل أسوأ عدو إلى أعظم رسول",
          "التحول كان مستحقاً",
          "كان شاول بالفعل قريباً من الله"
        ],
        hint: "يتعلق الأمر بقوة النعمة التحويلية",
        funFact: "⚡ من أعظم مضطهد إلى أعظم مرسل - معجزة نعمة!"
      }
    },

    64: {
      name: "بطرس وكرنيليوس",
      challenge: "بالحق أنا أجد أن الله لا يقبل الوجوه...",
      easy: {
        question: "ما كانت مهنة كرنيليوس؟",
        options: [
          "تاجر",
          "قائد مئة روماني",
          "كاهن",
          "كاتب"
        ],
        hint: "ضابط في الجيش الروماني",
        funFact: "🎖️ أول وثني يتحول رسمياً - انفتاح على غير اليهود!"
      },
      medium: {
        question: "ما الرؤيا التي رآها بطرس قبل لقاء كرنيليوس؟",
        options: [
          "ملاك يتحدث إليه",
          "ملاءة بحيوانات طاهرة ونجسة",
          "يسوع يظهر له",
          "هيكل مدمر"
        ],
        hint: "رؤيا عن الطهارة والنجاسة",
        funFact: "🕊️ ملاءة بحيوانات: الله يلغي التمييزات الغذائية والعرقية!"
      },
      hard: {
        question: "ما المبدأ الثوري الذي أسسه هذا التحول؟",
        options: [
          "الرومان متفوقون",
          "الله لا يحابي الوجوه - خلاص عالمي",
          "يجب التخلي عن التقاليد",
          "الختان عديم الفائدة"
        ],
        hint: "يتعلق الأمر بعالمية الخلاص",
        funFact: "🌍 ثورة روحية: الإنجيل لجميع الشعوب بلا استثناء!"
      }
    },

    65: {
      name: "كنيسة أنطاكية",
      challenge: "في أنطاكية دُعي التلاميذ مسيحيين أولاً...",
      easy: {
        question: "بماذا دُعي التلاميذ لأول مرة في أنطاكية؟",
        options: ["تلاميذ", "مسيحيين", "مؤمنين", "قديسين"],
        hint: "الاسم الذي ما زلنا نحمله اليوم",
        funFact: "✝️ 'مسيحيون' = 'مسحاء صغار' - اسم شرف أعطاه الوثنيون!"
      },
      medium: {
        question: "من جاء ليعلِّم في أنطاكية مع برنابا؟",
        options: [
          "بطرس",
          "بولس (شاول)",
          "يعقوب",
          "يوحنا"
        ],
        hint: "المضطهد السابق الذي أصبح رسولاً",
        funFact: "👥 برنابا يبحث عن بولس في طرسوس - بداية خدمة بولس!"
      },
      hard: {
        question: "لماذا أصبحت أنطاكية مهمة جداً في التاريخ المسيحي؟",
        options: [
          "كانت غنية",
          "أول مركز إرسالي نحو الوثنيين",
          "كانت موقعها جيداً",
          "كان لها قادة جيدون"
        ],
        hint: "يتعلق الأمر بالتوسع الإرسالي",
        funFact: "🚢 أنطاكية: ميناء إطلاق جميع رحلات بولس نحو أوروبا!"
      }
    }
  }
};

export default chapter5Translations;
